<!-- <div class="image-scroller" [class.expand]="isExpand" *ngIf="favImages.length > 0">
  <div class="carousel-container">
    <button class="btn-close btn btn-sm btn-primary transparent" (click)="hideGallery($event)">{{'Close' | translate}}</button>
    <carousel (activeSlideChange)="onNavCarousel($event)" [interval]="false" [showIndicators]="true"
      [activeSlide]="currentSlide" [noWrap]="true">
      <slide *ngFor="let favImage of favImages; let i = index">
        <div class="marker" [style.left]="((favImage.x * (640/3000)) - 20).toFixed(0) + 'px'"
          [style.top]="((favImage.y * (640/3000)) - 20).toFixed(0) + 'px'"></div>
        <img [src]="favImage.link" alt="image slide" style="display: block; height: 40em;">
      </slide>
    </carousel>
  </div>
  <div class="carousel-thumbnail">
    <div id="carouselThumbnail{{i}}" *ngFor="let favImage of favImages; let i = index" style="background-image: url('{{favImage.link}}')" [class.active]="i === currentSlide" class="image" (click)="showCarousel(i)"></div>
  </div>
  <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="50" class="carousel-thumbnail">
    <div *cdkVirtualFor="let favImage of favImages; let i = index" [style.backgroundColor]="i%2===0 ? 'red' : 'black'" style="background-image: url('{{favImage.link}}')" [class.active]="i === currentSlide" class="image" (click)="showCarousel(i)">{{favImage.link}}</div>
  </cdk-virtual-scroll-viewport>
  <div class="cdk-virtual-scroll-data-source" *ngIf="!isSpotlight">
    <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="80" class="viewport">
      <div *cdkVirtualFor="let favImage of favImages; let i = index"
        class="item" (click)="showCarousel(i)">
        <img [src]="favImage.link + '.small.JPG'" style="width: 100%;">
        <div class="btn-container">
          <i class="icon-clusters"></i>
          <i class="icon-download"></i>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
  <button class="btn btn-sm btn-light close-carousel" (click)="closeCarousel()">{{'Close' | translate}}</button>
</div> -->
<div class="cards" cdkDrag>
  <!-- <div class="card mb-0 mr-3">
    <div class="card-body">
      <ul class="list-group overflow-visible">
        <li class="list-group-item">
          <div class="toggle-container">
            <app-toggle-switch [selected]="isSpotlight" (change)="toggleSpotlight()"></app-toggle-switch>
            <i class="icon-orbit"></i>
          </div>
        </li>
      </ul>
    </div>
  </div> -->
  <ng-container *ngIf="!isThreeD">
    <a (click)="toggleSpotlight()" class="btn btn-sm btn-light btn-tool" [class.active]="isSpotlight">
      <i class="icon-orbit"></i>
      <span class="tooltip-text" style="margin-top: -2.8em; margin-left: -3em">{{'Rotate Map' | translate}}</span>
    </a>
    <a (click)="resetBearing()" class="btn btn-sm btn-light btn-tool">
      <i class="icon-north"></i>
      <span class="tooltip-text" style="margin-top: -2.8em; margin-left: -3.8em">{{'Re-Center Map' | translate}}</span>
    </a>
    <a (click)="resetPitch()" class="btn btn-sm btn-light btn-tool">
      <i class="icon-angles"></i>
      <span class="tooltip-text" style="margin-top: -2.8em; margin-left: -2.3em">{{'Tilt Map' | translate}}</span>
    </a>
  </ng-container>
</div>